import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import content from '../assets/content.json';

export default function NotFound() {
  return (
      <div style={{ padding: '50px', textAlign: 'center' }}>
        <h1>404 - Page Not Found</h1>
        <p>Sorry, the page you are looking for does not exist.</p>
          <Link to="/">Go to Homepage</Link>
      </div>
  );
}